import { useEffect, useState, useRef } from 'react';

function Delay({ delay = 1000, children }) {
    const [isActive, setIsActive] = useState(false);
    const timer = useRef();

    useEffect(() => {
        if (timer.current) clearTimeout(timer.current);
        timer.current = setTimeout(() => {
            setIsActive(true);
        }, delay);
        return () => {
            if (timer.current) clearTimeout(timer.current);
        };
    }, []);

    return <>{isActive && children}</>;
}

export default Delay;
